import React from 'react';
import { Route } from 'react-router-dom';

import { FEEDBACK, LOG, OFFERS } from 'services/types/viewTypes';
import CreateOfferProduct from 'components/offers/CreateOfferProduct';
import EditOfferProduct from 'components/offers/EditOfferProduct';
import FeedbackList from 'components/feedback/FeedbackList';
import Offer from 'components/offers/Offer';
import OfferDefaults from 'components/offers/OfferDefaults';
import Offers from 'components/offers/Offers';
import Permission from 'components/layout/Permission';
import OfferDashboard from 'components/reports/OfferDashboard';
import OfferLog from 'components/reports/OfferLog';
import OfferTimeline from 'components/reports/OfferTimeline';

const offers = (): JSX.Element[] => [
  <Route exact key="offers-route" path="/offers">
    <Permission type={OFFERS}>
      <Offers />
    </Permission>
  </Route>,
  // The basic information of the new offers of a department; before /offers/:id
  <Route exact key="offer-defaults-route" path="/offers/defaults">
    <Permission type={OFFERS}>
      <OfferDefaults />
    </Permission>
  </Route>,
  // The offer dashboard of the reports
  <Route exact key="offer-dashboard-route" path="/reports/offers">
    <Permission type={OFFERS}>
      <OfferDashboard />
    </Permission>
  </Route>,
  // The contracts and sites of the offers on a timeline
  <Route exact key="offer-timeline-route" path="/reports/timeline">
    <Permission type={OFFERS}>
      <OfferTimeline />
    </Permission>
  </Route>,
  // The feedback of the users, with the right to read or handle it
  <Route exact key="feedback-route" path="/reports/feedback">
    <Permission type={FEEDBACK}>
      <FeedbackList />
    </Permission>
  </Route>,
  // The log of all offers, with the right to read the log
  <Route exact key="offer-log-route" path="/reports/log">
    <Permission type={LOG}>
      <OfferLog />
    </Permission>
  </Route>,
  <Route exact key="create-offer-route" path="/offers/types/:typeId/create">
    <Permission type={OFFERS}>
      <Offer />
    </Permission>
  </Route>,
  <Route
    exact
    key="offer-route"
    path="/offers/:id/:type"
    render={({ match }) => (
      <Permission type={OFFERS}>
        {/* The key remounts the page when moving between offer revisions */}
        <Offer key={`${match.params.type}-${match.params.id}`} />
      </Permission>
    )}
  />,
  <Route
    exact
    key="create-offer-product-route"
    path="/offers/:id/:type/products/create"
  >
    <Permission type={OFFERS}>
      <CreateOfferProduct />
    </Permission>
  </Route>,
  <Route exact key="offer-product-route" path="/offers/products/:id/:type">
    <Permission type={OFFERS}>
      <EditOfferProduct />
    </Permission>
  </Route>,
];

export default offers;
